import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const AboutAPI = createApi({
  reducerPath: "aboutAPI",
  baseQuery: fetchBaseQuery({ baseUrl: BaseUrl,   prepareHeaders: (headers) => {
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    return headers;
}, }),
  endpoints: (builder) => ({
    getAboutBanner: builder.query({
      query: () => `page/list-page-banner`,
    }),
    getAboutPageContent: builder.query({
      query: () => `about/list-about-content`,
    }),
  }),
});

export const { useGetAboutBannerQuery, useGetAboutPageContentQuery } = AboutAPI;
